function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import PropTypes from 'prop-types';
import styled from 'styled-components';
import { px2rem, font, padding, getSpacing, getDisplay, mediaMinWidth } from '../utils/helpers';
var textVariant = ['lead', 'standard', 'mention'];

var isTextVariant = function isTextVariant(variant) {
  return textVariant.includes(variant);
};

var Text = styled.p(_templateObject(), function (_ref) {
  var _extends2;

  var theme = _ref.theme,
      variant = _ref.variant,
      color = _ref.color,
      fullWidth = _ref.fullWidth;

  if (!isTextVariant(variant)) {
    return undefined;
  }

  var breakpoints = theme.breakpoints,
      colors = theme.colors,
      text = theme.text;
  var shared = text.shared;
  var _text$variant = text[variant],
      small = _text$variant.small,
      xsmall = _text$variant.xsmall,
      medium = _text$variant.medium,
      large = _text$variant.large,
      xlarge = _text$variant.xlarge,
      xxlarge = _text$variant.xxlarge;
  return _extends({
    margin: 0,
    color: colors[color]
  }, font(_extends({}, shared.normal, xsmall)), padding(xsmall), (_extends2 = {
    maxWidth: !fullWidth && xsmall.maxWidth && px2rem(xsmall.maxWidth),
    strong: _extends({}, font(shared.bold))
  }, _extends2[mediaMinWidth(breakpoints.small)] = small && _extends({}, font(small), padding(small), {
    maxWidth: !fullWidth && small.maxWidth && px2rem(small.maxWidth)
  }), _extends2[mediaMinWidth(breakpoints.medium)] = medium && _extends({}, font(medium), padding(medium), {
    maxWidth: !fullWidth && medium.maxWidth && px2rem(medium.maxWidth)
  }), _extends2[mediaMinWidth(breakpoints.large)] = large && _extends({}, font(large), padding(large), {
    maxWidth: !fullWidth && large.maxWidth && px2rem(large.maxWidth)
  }), _extends2[mediaMinWidth(breakpoints.xlarge)] = xlarge && _extends({}, font(xlarge), padding(xlarge), {
    maxWidth: !fullWidth && xlarge.maxWidth && px2rem(xlarge.maxWidth)
  }), _extends2[mediaMinWidth(breakpoints.xxlarge)] = xxlarge && _extends({}, font(xxlarge), padding(xxlarge), {
    maxWidth: !fullWidth && xxlarge.maxWidth && px2rem(xxlarge.maxWidth)
  }), _extends2));
}, getSpacing, getDisplay);
Text.propTypes = {
  variant: PropTypes.oneOf(textVariant),
  color: PropTypes.string,
  fullWidth: PropTypes.bool
};
Text.defaultProps = {
  variant: 'standard',
  color: 'black',
  fullWidth: false
};
export default Text;